export default class MatchType {
  static FOOTBALL = 1;
  static BASKETBALL = 2;
}
